import i18next from 'i18next';
import { useTranslation } from 'i18next-vue';

import { AppLocale } from '@shared/i18n';

import cashbackRu from './ru.json';
import cashbackKk from './kk.json';

const NAMESPACE_NAME = 'cashback';

export function useCashbackLocales() {
  i18next.addResourceBundle(
    i18next.language,
    NAMESPACE_NAME,
    i18next.language === AppLocale.RU ? cashbackRu : cashbackKk,
    true,
  );

  return useTranslation(NAMESPACE_NAME);
}
